import type { ClientOverviewRepository } from "../repositories/ClientOverviewRepository";
import type { ClientOverviewBootstrapEntity } from "../entities/ClientOverviewBootstrapEntity";

export class GetClientOverviewBootstrapUseCase {
  constructor(private readonly repository: ClientOverviewRepository) {}

  async execute(): Promise<ClientOverviewBootstrapEntity> {
    return this.repository.getClientOverviewBootstrap();
  }
}
